import React from "react";
import { Card, CardContent } from '@/components/ui/card';
import { Heading, Text } from '@/components/ui/typography';
import { cn } from '@/lib/utils';

export default function DesktopLoader({ text = "Preparing your test…" }) {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <Card className="max-w-md w-full mx-4">
        <CardContent className="p-8 text-center">
          <div className="w-16 h-16 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <Heading level="h2" className="text-2xl font-bold mb-2">AI Evaluator</Heading>
          <Text>{text}</Text>
        </CardContent>
      </Card>
    </div>
  );
}
